import React from 'react';
import { motion } from 'framer-motion';
import { painPoints } from '../data/painPoints';
export function PainPoints() {
  return <section aria-label="Problems" className="border-y border-white/5 bg-ink-2" data-id="element-113" data-mp="2lmsqcmz6p8ku">
      <div className="mx-auto max-w-4xl px-5 pb-12 pt-10" style={{
      paddingBottom: "8px"
    }} data-id="element-114" data-mp="26xehrh3fmv6i">
        <h2 className="text-center font-display text-[25px] font-black text-white sm:text-4xl" data-id="element-115" data-mp="2bwh9jzuej4wj">
          ❌ How many more subjects are you going to retake like this?
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-center text-base leading-relaxed text-white/70" data-id="element-116" data-mp="21zupvedtajw3">
          You're a university student. You want to pass. But nobody told you that you'd spend your
          days reading without understanding, suffering mental blocks during exams, and reaching the
          end of every semester without knowing what went wrong.
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-center text-lg font-bold text-gold" data-id="element-117" data-mp="3ibs1c9r5kogq">
          It's not lack of intelligence. It's not lack of effort. It's lack of a system.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2" data-id="element-118" data-mp="1yykd1c2u3606">
          {painPoints.map((p, i) => <motion.div key={p.title} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 2 * 0.08
        }} className="flex gap-3 rounded-xl border border-white/10 bg-ink p-5" data-id="element-119" data-mp="1u1buhadrwzye" data-mpi={i}>
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-navy/50 text-sm" aria-hidden="true" data-id="element-120" data-mp="1b2pvc11thix4">
                {p.emoji}
              </span>
              <div data-id="element-121" data-mp="1p04ongv6yaud">
                <h3 className="text-sm font-bold text-white" data-id="element-122" data-mp="1k3o1aovtg0ic">{p.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-white/60" data-id="element-123" data-mp="1k5qwrofqmlug">{p.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-124" data-mp="2vjconhczf1jo">
          <p className="font-display text-2xl font-bold text-white sm:text-3xl" data-id="element-125" data-mp="2vkno54ze9n4z">
            ✨ What if this were the last semester you started without a real method?
          </p>
          <p className="mt-3 text-lg font-semibold text-gold" data-id="element-126" data-mp="1y2ooz8ljhaof">The next exam can be different.</p>
        </div>
      </div>
    </section>;
}